export enum WatchlistCategory {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  InProduction = 'IN_PRODUCTION',
  Planned = 'PLANNED',
  Upcoming = 'UPCOMING',
}
